<style lang="scss">
.vslist-detail {
	min-height: 20px;
	padding: 16px;
	margin-bottom: 20px;
	background-color: #f3f7f9;
	border: 1px solid #e4eaec;
	border-radius: 3px;
	width: 80%;
}
.margin-right-10 {
	margin-right: 10px;
}
</style>

<template>
	<div>
		<!-- 编辑仓库 -->
		<div class="lookinfo" v-show="editWarehouse">
			<Breadcrumb class="tablelist-header">
				<BreadcrumbItem>{{$t('global.common.edit',{defaultValue:'编辑'})}}{{$t('fbb.warehouse.virtual_warehouse',{defaultValue:'虚拟仓'})}}</BreadcrumbItem>
			</Breadcrumb>
			<Alert class="padding-10">
                <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
            </Alert>
			<div class="bg-fff shadow padding-bottom-20">
				<header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
				<Form :label-width="100" ref="form" :model="formData" class="margin-15">
					<Row>
						<Col span="6">
							<FormItem prop="name" :label="$t('global.common.name',{defaultValue:'名称'})" :rules="required">
								<Input v-model="formData.name"/>
							</FormItem>
						</Col>
						<Col span="6">
							<Button @click="seeDetail">{{$t('fbb.alloment.query_detail',{defaultValue:'查看详情'})}}</Button>
						</Col>
					</Row>
					<FormItem :label="$t('global.common.project',{defaultValue:'项目'})">
						<!-- <span>{{formData.lineId}}</span> -->
						<Select v-model="formData.lineId" filterable disabled>
							<Option v-for="item in products" :value="item.id" :key="item.id">{{ item.name }}</Option>
						</Select>
					</FormItem>
					<FormItem label="ERPSKU">
						<span class="margin-right-10">{{formData.erpSku}}</span>
						<!-- <Input v-model="formData.erpSku" @on-blur="getProductId" disabled/> -->
					</FormItem>
					<FormItem prop="stockGroups" :label="$t('erp.virtualstore.openwirtualware',{defaultValue:'开启虚拟仓'})">
						<CheckboxGroup v-model="formData.stockGroups">
							<Checkbox :label="1" disabled>T1</Checkbox>
							<Checkbox :label="2" disabled>T2</Checkbox>
							<Checkbox :label="3" disabled>T3</Checkbox>
							<Checkbox :label="4" disabled>T4</Checkbox>
							<Checkbox :label="5" disabled>T5</Checkbox>
						</CheckboxGroup>
					</FormItem>
					<FormItem prop="organizationWarehouses" :label="$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'})" :rules="required">
						<Transfer
							:data="warehousesTarget"
							:target-keys="formData.organizationWarehouses"
							:list-style="listStyle"
							filterable
							:filter-method="filterMethod"
							@on-change="handleStoreChange"
						></Transfer>
					</FormItem>
					<FormItem :label="$t('fbb.costmanage.explain',{defaultValue:'说明'})">
						<Input v-model="formData.description" :rows="4" type="textarea"/>
					</FormItem>
				</Form>
				<footer class="text-center">
					<Button type="primary" class="width-15per" @click="nextStep">{{$t('fbb.accountmanage.next_step',{defaultValue:'下一步'})}}</Button>
					<Button class="width-15per" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
				</footer>
			</div>
			<!-- 查看信息按钮 -->
			<Modal class="hidefooter" v-model="operate.show" :mask-closable="false" v-bind="operate">
				<component :is="operate.component" @on-close="operate={}" v-bind="operate" v-if="operate.show"/>
				<footer slot="footer" v-show="false"></footer>
			</Modal>

			<compDelayloading :loading="loading" :delay="loading!==true" @on-cancel="cancel" @on-back="goback"></compDelayloading>

		</div>
		<!-- 编辑比例 -->
		<div class="lookitem" v-show="editAllot">
			<Breadcrumb class="tablelist-header">
				<BreadcrumbItem>{{$t('erp.virtualstore.editwareallocratio',{defaultValue:'编辑虚拟仓分配比例'})}}</BreadcrumbItem>
			</Breadcrumb>
			<Alert class="padding-10">
                <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
            </Alert>
			<Row class="bg-fff shadow padding-bottom-20">
				<Col span="24">
					<header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
				</Col>
				<Col span="12">
					<span class="item-label">{{$t('global.common.name',{defaultValue:'名称'})}}：</span>
					<a class="item-content" @click="seeDetail">{{formData.name}}</a>
				</Col>
				<Col span="12">
					<span class="item-label">{{$t('global.common.project',{defaultValue:'项目'})}}：</span>
					<span class="item-content">{{formData.lineId|transferText('name',products)}}</span>
				</Col>
				<Col span="12">
					<span class="item-label">ERPSKU：</span>
					<span class="item-content">{{formData.erpSku}}</span>
				</Col>
				<Col span="24">
					<Form :label-width="100" ref="formAllot">
						<section v-for="(item,index) in svRules" class="clearfix" :key="index">
							<header class="item-label">{{item.stockGroupName}}</header>
							<section class="item-content vslist-detail">
								<div class="clearfix padding-top-5" v-for="data in item.orgWarehouseIds" :key="data.id">
									<span class="width-80per pull-left">{{data.warehouseTitle}}({{data.warehouseCode}})</span>
									<InputNumber class="pull-left" v-model="data.assignPercent"/>%
								</div>
							</section>
						</section>
					</Form>
				</Col>
				<Col span="24" class="text-center padding-10">
					<Button type="primary" class="width-15per" @click="routeBack">{{$t('erp.virtualstore.laststep',{defaultValue:'上一步'})}}</Button>
					<Button type="primary" class="width-15per" @click="commitForm">{{$t('erp.distribution.confirm_submit',{defaultValue:'提交'})}}</Button>
					<Button class="width-15per" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
				</Col>
			</Row>
		</div>
		<!-- <Spin size="large" fix v-if="loading"></Spin> -->
	</div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import { HttpProductErpSku } from '@/service/boss/dictionary'
import {
	HttpVsDetail, HttpUpdateVs, HttpSaveVs, HttpEditorWarehouse
} from '@/service/boss/allot';
import compDetail from './detail';
export default {
	components: {
		compDetail,
		compDelayloading: () => import("@components/templates/delayloading"),
	},
	data() {
		return {
			loading: false,
			// type: this.$route.params.type,
			id: this.$route.params.id,
			listStyle: {
				width: "260px",
				height: '360px',
			},
			formData: {
				name: '',
				lineId: '',
				erpSku: '',
				rules: [],
				stockGroups: [],
				organizationWarehouses: [],
				description: '',
				productId: '',
			},
			required: [{
				required: true,
				message: this.$t('global.common.required',{defaultValue:'该信息不能为空,请填写'})
			}],
			editWarehouse: true,
			editAllot: false,
			svRules: [],
			operate: {
				id: null,
				title: "",
				show: false,
				component: null
			},
		}
	},
	created() {
		this.getDetail();
	},
	computed: {
		...mapState('boss', ['products']),
		...mapGetters('boss', ['warehouses']),
		warehousesTarget() {
			return this.warehouses.map(item => {
				return {
					key: item.id,
					label: `${item.title}(${item.code})`,
				}
			})
		},
	},
	methods: {
		// 查看页面
		seeDetail() {
			this.operate = {
				id: this.id,
				title: this.$t('global.common.operation_see',{defaultValue:'查看'}),
				component: 'compDetail',
				show: true,
				width: 760,

			}
		},
		cancel() {
			this.$router.push({ name: "vstorelist" })
		},

		handleStoreChange(targetKeys, direction, moveKeys, $event) {
			// 仓库id传值
			// console.log(targetKeys)
			this.formData.organizationWarehouses = targetKeys;
		},
		handleResponse(data = {}) {
			// console.log(data)
			let { name, lineId, erpSku, description, productId, stockVirtualGroupRules = [] } = data;
			let organizationWarehouses = (stockVirtualGroupRules[0] || {}).stockVirtualGroupRuleItemEntity || [],
				stockGroups = stockVirtualGroupRules.map(item => {
					return item.stockGroupId;
				});
			organizationWarehouses = organizationWarehouses.map(item => {
				return item.orgWarehouseId;
			});
			this.formData = { name, lineId, erpSku, description, productId, organizationWarehouses, stockGroups };
			// console.log(this.formData)
			// this.svRules = data.stockVirtualGroupRules
		},
		handleformDta(data) {
			// console.log(data)
			let { name, lineId, erpSku, description, status } = data;
			// this.formData = { name, lineId, erpSku, description, status };
			this.svRules = (data.stockGroups || []).map((item, index) => {
				let accountslist = data.rules.filter((items) => {
					return items.stockGroupId == item;
				});
				if (accountslist.length > 0) {
					accountslist = accountslist[0].stockVirtualGroupRuleAccountEntity;
				}
				let itemlist = data.organizationWarehouses || [];
				itemlist = itemlist.map((ware) => {
					let warelist = data.rules.filter((rule) => {
						return rule.stockGroupId == item;
					});
					if (warelist.length > 0) {
						warelist = warelist[0].stockVirtualGroupRuleItemEntity;
					}
					const lastWare = warelist.filter((list) => {
						return list.orgWarehouseId == ware;
					});
					if (lastWare.length == 0) {
						const wareEntity = this.warehouses.filter((house) => {
							return house.id == ware;
						})[0];
						return {
							warehouseTitle: wareEntity.title,
							warehouseCode: wareEntity.code,
							orgWarehouseId: ware,
							assignPercent: 0,
							// id: item + '_' + wareEntity.id
						}
					} else {
						return lastWare[0];
					}
				});
				let rule = data.rules.filter((items) => {
					return items.stockGroupId == item;
				})[0];
				if (!rule) {
					rule = {};
					rule.stockGroupId = item;
					if (item == 1) {
						rule.stockGroupName = 'T1'
					}
					if (item == 2) {
						rule.stockGroupName = 'T2'
					}
					if (item == 3) {
						rule.stockGroupName = 'T3'
					}
					if (item == 4) {
						rule.stockGroupName = 'T4'
					}
					if (item == 5) {
						rule.stockGroupName = 'T5'
					}
				}
				rule.stockVirtualGroupRuleAccountEntity = accountslist;
				rule.orgWarehouseIds = itemlist;
				// 编辑可用渠道的,在编辑仓库时不需要展示
				// this.$set(this.ruleAccounts, index, rule.stockVirtualGroupRuleAccountEntity.map(json => {
				//     return json.accountId;
				// }));
				return rule;
			});
			// console.log(this.svRules)
		},
		handleRequest() {
			// console.log()
			let warehousesList = [];
			// console.log(this.formData)
			warehousesList = this.formData.rules.map((items, index) => {
				let ruleid = items.id;
				let stockGroupId = items.stockGroupId;
				let stockGroupName = items.stockGroupName;
				let orgWarehouseIds = items.orgWarehouseIds.map((item) => {
					return {
						orgWarehouseId: item.orgWarehouseId,
						assignPercent: item.assignPercent
					}
				})
				return {
					id: ruleid,
					stockGroupId: stockGroupId,
					stockGroupName: stockGroupName,
					orgWarehouseIds: orgWarehouseIds
				}
			})
			return warehousesList
		},
		goback() {
			this.loading=false;
			this.formData = { ...this.formData };
			this.editAllot = true;
			this.editWarehouse = false;
		},
		routeBack() {
			this.loading=false;
			this.editAllot = false;
			this.editWarehouse = true;
		},
		async getDetail() {
			// if (this.type !== 'edit') return;
			this.loading = true;
			HttpVsDetail({
				id: this.id
			}).then(res => {
				this.handleResponse(res.data);
				this.formData.rules = res.data.stockVirtualGroupRules;
				this.loading = false;
			}, err => {
				this.loading = false;
				this.errorMessage(err.message);
			});
		},
		async nextStep() {
			let valid = await this.$refs['form'].validate();
			if (!valid) return;
			this.loading = 1;
			this.handleformDta(this.formData);
		},
		// 添加自定义搜索函数,不区分大小写搜索
		filterMethod(data, query) {
			return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
		},
		// 提交
		commitForm() {
			let dataWarehouse = this.handleRequest();
			HttpEditorWarehouse({
				id: this.id,
				name: this.formData.name,
				orgWarehouseIds: this.formData.organizationWarehouses,
				description: this.formData.description,
				stockVirtualGroupRules: dataWarehouse
			}).then(res => {
				this.$Message.success(res.message);
				this.loading = false;
				this.$router.push({ name: "vstorelist" })
			}, err => {
				if (err.code == 500) {
					this.$Message.error(this.$t('erp.virtualstore.nullnumber',{defaultValue:'数值不能为空'}));
					this.loading = false;
				} else {
					this.errorMessage(err.message);
					this.loading = false;
				}
			})
		},
	},
	
}
</script>

